export default "__VITE_ASSET__cee7e51a__"